import { render, staticRenderFns } from "./ElementoItemForm.vue?vue&type=template&id=e36a1686&scoped=true"
import script from "./ElementoItemForm.vue?vue&type=script&lang=js"
export * from "./ElementoItemForm.vue?vue&type=script&lang=js"
import style0 from "./ElementoItemForm.vue?vue&type=style&index=0&id=e36a1686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36a1686",
  null
  
)

export default component.exports